"use client";

export { Swiper, SwiperSlide } from "swiper/react";
